
export default function CTA() {
  return (
    <section className="bg-[#F8F6F3]">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        {/* Left side - Image */}
        <div className="relative h-96 lg:h-auto">
          <img 
            src="https://public.readdy.ai/ai/img_res/da41b34042599aee7e188ea4d90c569e.jpg" 
            alt="Professional partnership" 
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/20 to-transparent"></div>
          <div className="absolute bottom-8 left-8">
            <span className="inline-block px-4 py-2 bg-white/90 backdrop-blur-sm rounded-full text-xs font-medium text-gray-800 mb-4">
              Comienza aquí
            </span>
            <h3 className="text-4xl lg:text-5xl font-bold text-white leading-tight drop-shadow-lg">
              Cada proceso<br />
              comienza con<br />
              una conversación
            </h3>
          </div>
        </div>
        
        {/* Right side - CTA */}
        <div className="flex items-center justify-center p-12 lg:p-20 bg-[#F8F6F3]">
          <div className="max-w-md w-full text-center">
            <h3 className="text-4xl font-bold text-[#1A2B4A] mb-6">¿Listo para conectar?</h3>
            <p className="text-lg text-gray-700 leading-relaxed mb-12">
              Ya sea que busques talento internacional cualificado o una oportunidad profesional en Europa, 
              estamos aquí para diseñar la conexión perfecta.
            </p>
            
            <div className="space-y-4">
              <a 
                href="#contact" 
                className="flex items-center justify-center w-full px-8 py-4 bg-[#1A2B4A] text-white text-base font-medium rounded-lg hover:bg-[#2A3B5A] transition-all cursor-pointer whitespace-nowrap group"
              >
                Buscar talento internacional
                <i className="ri-arrow-right-line ml-2 text-lg group-hover:translate-x-1 transition-transform"></i>
              </a>
              
              <a 
                href="#contact" 
                className="flex items-center justify-center w-full px-8 py-4 bg-gray-800 text-white text-base font-medium rounded-lg hover:bg-gray-900 transition-all cursor-pointer whitespace-nowrap group"
              >
                Explorar oportunidades en Europa
                <i className="ri-arrow-right-line ml-2 text-lg group-hover:translate-x-1 transition-transform"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
